import { useContext } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { ContentContext } from "../context/ContentProvider"; // Adjust path if needed
import "./ActivitiesForm.css";

function ActivitiesForm() {
  const { content, setContent } = useContext(ContentContext);
  const navigate = useNavigate();  // Initialize the navigation hook
  const apiUrl = process.env.REACT_APP_API_URL;
  

  // Submit handler that navigates to /activities after submission
 const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitting:", content.activitiesText, content.activitiesStyle);

    try {
      const response = await fetch(`${apiUrl}/api/content`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          activitiesText: content.activitiesText,
          activitiesStyle: content.activitiesStyle,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Update the context with data returned by the server.
        setContent(data);
        // Navigate to the Activities page after successful submission.
        navigate("/activities");
      } else {
        const errorData = await response.json();
        console.error("Failed to submit content:", errorData);
      }
    } catch (error) {
      console.error("Error during POST:", error);
    }
  };

  // Handler for updating the text input
  const handleTextChange = (e) => {
    setContent({ ...content, activitiesText: e.target.value });
  };

  // Handler for updating the text color
  const handleColorChange = (e) => {
    setContent({
      ...content,
      activitiesStyle: { ...content.activitiesStyle, color: e.target.value },
    });
  };

  // Handler for toggling bold style
  const handleBoldChange = (e) => {
    setContent({
      ...content,
      activitiesStyle: { ...content.activitiesStyle, bold: e.target.checked },
    });
  };

  // Handler for toggling italic style
  const handleItalicChange = (e) => {
    setContent({
      ...content,
      activitiesStyle: { ...content.activitiesStyle, italic: e.target.checked },
    });
  };

  return (
    <div className="activities-form-container">
      <form onSubmit={handleSubmit}>
        <h2>Edit Activities Text</h2>
        <textarea
          value={content.activitiesText || ""}
          onChange={handleTextChange}
          placeholder="Enter your activities text here..."
          rows="6"
        />
        <div className="style-options">
          <div className="field-group">
            <label htmlFor="textColor">Text Color:</label>
            <input
              type="color"
              id="textColor"
              value={content.activitiesStyle?.color || "#000000"}
              onChange={handleColorChange}
            />
          </div>
          <div className="field-group">
            <label htmlFor="bold">Bold:</label>
            <input
              type="checkbox"
              id="bold"
              checked={content.activitiesStyle?.bold || false}
              onChange={handleBoldChange}
            />
          </div>
          <div className="field-group">
            <label htmlFor="italic">Italic:</label>
            <input
              type="checkbox"
              id="italic"
              checked={content.activitiesStyle?.italic || false}
              onChange={handleItalicChange}
            />
          </div>
        </div>
        <button type="submit">Submit</button>
      </form>
      <div className="preview">
        <h3>Preview:</h3>
        <div
          className="preview-text"
          style={{
            color: content.activitiesStyle?.color || "#000000",
            fontWeight: content.activitiesStyle?.bold ? "bold" : "normal",
            fontStyle: content.activitiesStyle?.italic ? "italic" : "normal",
            textAlign: "center",
            whiteSpace: "pre-wrap",
          }}
        >
          {content.activitiesText || "No activities content available."}
        </div>
      </div>
    </div>
  );
}

export default ActivitiesForm;
